import { getPreviuosMonthDate, getLastDayOfMonth } from '@/utils'

export const state = {
  report: 'report_1',
  startDate: getPreviuosMonthDate(),
  endDate: getLastDayOfMonth(new Date()),
  status: 'all',
  objectStatus: 'all',
  parent: 'all',
  performer: 'all',
  manager: [],
  field_managers: [],
  onlyError: true
}

export const mutations = {
  SET_REPORTS_VALUE (state, { field, value }) {
    state[field] = value
  }
}

export default {
  state,
  mutations
}
